(function($, Cobalt, undefined) {
    Cobalt.Navigation = {
        initialize: function() {
            var navigationSelector = "#navigation";
        },
        enableDropDownMenus: function() {
            $(Cobalt.Navigation.navigationSelector + " .section ul").css('visibility', 'hidden');
            $(Cobalt.Navigation.navigationSelector + " .section").hover(function() {
                $(this).addClass("hover");
                $('ul:first', this).css('visibility', 'visible');

            }, function() {

                $(this).removeClass("hover");
                $('ul:first', this).css('visibility', 'hidden');

            });

            $("ul#nav li ul li:has(ul)").find("a:first").append(" &raquo; ");

        }
    };
})(jQuery, Cobalt);


// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.Navigation.js